import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import PropTypes from 'prop-types';
import { useCanDoAction } from 'hooks/useCanDoAction';

const AuthCheck = ({ scope, action, showWarning=false, children }) => {
  const canDo = useCanDoAction(scope, action);
  return canDo ? children : showWarning ? <Alert severity="warning"><AlertTitle><strong>Permissions Error</strong></AlertTitle>Your role in MFS does not grant access to this item.</Alert> : null
}

AuthCheck.propTypes = {
  scope: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  showWarning: PropTypes.bool,
  children: PropTypes.node.isRequired
}

export default AuthCheck;